import type { RTSPEndpoint } from '@repo/frontend-types';

/**
 * What a stream is called, in the interface — description, then BID, then its id.
 *
 * One rule, for the same reason `cameraDisplayName` (now in `@repo/front-end-utils`) is one rule: three copies of a
 * fallback is how three surfaces start calling one thing three names. The camera wall applies the
 * same ladder in `@repo/ui` to produce a tile's name, so a stream that reads "Free weights" on the
 * tile must not read "RTSP-FW" in the dialog header the tile opens.
 */
export const streamDisplayName = (stream: RTSPEndpoint): string =>
  stream.description?.trim() || stream.bid || `Stream ${stream.id}`;
